<template>
	<div class="d-flex pl-4">
		<span class="text">No data to display</span>
		<span class="hatch ml-2"></span>
	</div>
</template>

<script>

export default {
	name: "NoData",
};
</script>

<style>
div.empty {
    width: 97%;
}
span.text {
	flex-grow: 0;
	color: #d9d9d9;
}
.hatch {
	flex-grow: 1;
	opacity: 0.5;
	background-image: linear-gradient(
		135deg, 
		#d9d9d9 25%, 
		transparent 25%, 
		transparent 50%, 
		#d9d9d9 50%, 
		#d9d9d9 75%, 
		transparent 75%, 
		transparent
	);
	background-size: 5px 5px;
}
</style>